
import _ from "lodash";

export function crossDomainPost(url,data) {

    // Add the iframe with a unique name
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    // construct a form with hidden inputs, targeting the iframe
    var form = document.createElement("form");
    form.action = url;
    form.acceptCharset="UTF-8"
    form.method = "POST";
    form.enctype="application/x-www-form-urlencoded"

    // repeat for each parameter
    _.forEach(Object.keys(data),(key)=>{
        var input = document.createElement("textarea");
        //input.type = "text";
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
    });

    iframe.contentDocument.body.appendChild(form);
    form.submit();
}